import React from 'react'
import { Alert } from 'antd'

interface NoticeBannerProps {
  variant: 'warn' | 'info'
  children: React.ReactNode
}

const NoticeBanner: React.FC<NoticeBannerProps> = ({ variant, children }) => (
  <Alert
    type={variant === 'warn' ? 'warning' : 'info'}
    showIcon={false}
    className={`um-refactor__notice um-refactor__notice--${variant}`}
    message={<span>{children}</span>}
  />
)

export default NoticeBanner
